import React from 'react';
import Axios from 'axios';
import { Tooltip } from 'reactstrap';

import moment from 'moment';
import Users from './users/Users';

// references - regex etc
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
// https://developer.mozilla.org/fr/docs/Web/JavaScript/Reference/Objets_globaux/RegExp/test
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
const TABLE_NBCOL = 5;
const PAGER_DISPPAGES = 4;
const PAGER_PAGESIZE = 20;

const ADMIN_LVL_MASTER = 0;				// same as Users.js
const ADMIN_LVL_SEASONS = 3;
const ADMIN_LVL_ADMINPLAYERS_LIMIT = ADMIN_LVL_SEASONS;

class Players extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			// admin players
	    isAuthenticated: this.props.auth.isAuthenticated(),
			profile: this.props.auth.getProfile(),
			adminAccess: {
				auth: this.props.auth,
				globalAccessLevel: 99,
				adminValidatedAccessLevel: 99		// not used here
			},
			isAdmin: false,

			ratingTypes: [],
			filtRatingTypeId: "0",
			filtRatingType: {
				name: '',
				values: []
			},

			filtPlayers: '',
			filtRating: 'Toutes les cotes',
			filtSexe: 'Tous',

			tableRows: [],
      showRatingsPlayerIdx: new Array(PAGER_PAGESIZE).fill(false),

      sortParams: {
				sortFieldIdx: 0,
				sortOrder: 'asc',
				sortClass: []
			},

			pager: {
				startIndex: 0,
				totalPages: 1,
				pages: [1],
				currentPage: 1,
				pageSize: PAGER_PAGESIZE,
				endIndex: PAGER_PAGESIZE - 1,
				totalItems: 0
			},

			tooltipOpen: new Array(PAGER_PAGESIZE).fill(false),
			loading: true,
		};
    this.toggleTooltip = this.toggleTooltip.bind(this);

		this.initFilters = this.initFilters.bind(this);
		this.handleSelectRatingType = this.handleSelectRatingType.bind(this);
		this.handleFiltPlayersChange = this.handleFiltPlayersChange.bind(this);
		this.handleFiltRatingChange = this.handleFiltRatingChange.bind(this);
		this.handleFiltSexeChange = this.handleFiltSexeChange.bind(this);
		this.handleAddEditPlayerClick = this.handleAddEditPlayerClick.bind(this);
    this.handlePageSizeChange = this.handlePageSizeChange.bind(this);

		this.createTableRow = this.createTableRow.bind(this);
		this.handleSortTable = this.handleSortTable.bind(this);
		this.optRatingTypes = this.optRatingTypes.bind(this);
		this.optRatingTypeValues = this.optRatingTypeValues.bind(this);
	}

  toggleTooltip(i) {
  	//console.log('toggleTooltip: ' + i)
    const newArray = this.state.tooltipOpen.map((element, index) => {
      return (index === i ? !element : false);
    });
    this.setState({
      tooltipOpen: newArray
    });
  }

	componentDidMount() {
		//console.log('Players: componentDidMount');
		this.initiatePageData();
		this.initiatePagerSizeWithData(this.state.filtPlayers, this.state.filtRatingTypeId, this.state.filtRating, this.state.filtSexe, true);
	}

	UNSAFE_componentWillReceiveProps() {
		//console.log('Players: UNSAFE_componentWillReceiveProps');
	}

	initiatePageData() {
		var _this = this;

		// get admin rights
		this.getAdminRightsInfo(function(adminAccess) {

	  	var isAdmin = (adminAccess.globalAccessLevel <= ADMIN_LVL_ADMINPLAYERS_LIMIT);

			// get rating types
			Axios.get('/api/ratingTypes').then(function(response) {
				
				var ratingTypes = response.data;
				
				_this.setState({
					adminAccess: adminAccess,
					isAdmin: isAdmin,
					ratingTypes: response.data
				})
			});
		});
	}

	initiatePagerSizeWithData(filtPlayers, filtRatingTypeId, filtRating, filtSexe, resetSorting) {
		var _this = this;
		var sortParams = {
			sortFieldIdx: 0,
			sortOrder: 'asc',
			sortClass: []
		}
		if (!resetSorting) {
			sortParams = this.state.sortParams;
		}

		sortParams.sortClass = [];
		for(var i = 1; i < (TABLE_NBCOL - 1); i++) {
			sortParams.sortClass[i] = '';
		}
		sortParams.sortClass[sortParams.sortFieldIdx] = "statelo-sorting_" + sortParams.sortOrder;

		// Init pager
		var pager = {
			totalPages: 1,
			pages: [1],
			currentPage: 1,
			pageSize: PAGER_PAGESIZE,
			startindex: 0,
			endIndex: PAGER_PAGESIZE-1,
			totalItems: 0,
		};

		// prevent empty or dots parameters
		filtPlayers = encodeURIComponent(filtPlayers.replace(/\./g, ' '));

		if (filtPlayers === '') {
			filtPlayers = 'NOPLAYERFILTER';
		}
		if (filtRating === 'Toutes les cotes') {
			filtRating ='ALLRATINGS';
		}
		if (filtSexe === 'Tous') {
			filtSexe ='ALLSEXES';
		}

		Axios.get('/api/players' +
			'/filtPlayers/' + filtPlayers + 
			'/filtRatingTypeId/' + filtRatingTypeId + 
			'/filtRating/' + filtRating + 
			'/filtSexe/' + filtSexe + 
			'/count')
		.then(function(response) {
			pager.totalItems = response.data.count;
			_this.setPage(1, pager, sortParams);
		});

	}

  setPage(page, pager, sortParams) {
		// set optional parameters
    // var pager = pager || this.state.pager;
    pager = (pager === undefined) ? this.state.pager : pager;

    if ((page < 1) || (page > pager.totalPages)) {
    	console.log('ERR: setPage unexpected return');
    	return;
    }

    sortParams = (sortParams === undefined) ? this.state.sortParams : sortParams;

    // get new pager object for specified page
    pager = this.getPager(pager.totalItems, page, pager.pageSize);

    // call change page function in parent component
    this.loadData(pager, sortParams);
  }

  getPager(totalItems, currentPage, pageSize) {

    // default to first page
    // currentPage = currentPage || 1;
    // currentPage = (currentPage === undefined) ? 1 : currentPage;
 
    // default page size is 10
    pageSize = (pageSize === undefined) ? PAGER_PAGESIZE : pageSize;

    // calculate total pages
    var totalPages = Math.ceil(totalItems / pageSize);

    var startPage, endPage;
    if (totalPages <= PAGER_DISPPAGES) {
      // less than 10 total pages so show all
      startPage = 1;
      endPage = totalPages;
    } else {
      // more than 10 total pages so calculate start and end pages
      if (currentPage <= ((PAGER_DISPPAGES / 2) + 1)) {
        startPage = 1;
        endPage = PAGER_DISPPAGES;
      } else if (currentPage + ((PAGER_DISPPAGES / 2) - 1) >= totalPages) {
        startPage = totalPages - (PAGER_DISPPAGES - 1);
        endPage = totalPages;
      } else {
        startPage = currentPage - Math.ceil(PAGER_DISPPAGES / 2);
        endPage = currentPage + Math.ceil((PAGER_DISPPAGES / 2) - 1);
      }
    }

    // calculate start and end item indexes
    var startIndex = (currentPage - 1) * pageSize;
    var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);
 
    // create an array of pages to ng-repeat in the pager control
    // var pages = _.range(startPage, endPage + 1);		// lodash function
 		var pages = Array.apply(0, Array(endPage - startPage + 1)).map(function (element, index) { 
	  	return index + startPage;  
  	});
    
    // return object with all pager properties required by the view
    return {
      totalItems: totalItems,
      currentPage: currentPage,
      pageSize: pageSize,
      totalPages: totalPages,
      startIndex: startIndex,
      endIndex: endIndex,
      pages: pages
    };
  }

	loadData(pager, sortParams) {

		var _this = this;

		// prevent empty or dots parameters
		var filtPlayers = encodeURIComponent(this.state.filtPlayers.replace(/\./g, ' '));
		if (filtPlayers === '') {
			filtPlayers = 'NOPLAYERFILTER';
		}

		var filtRating = this.state.filtRating;
		if (filtRating === 'Toutes les cotes') {
			filtRating ='ALLRATINGS';
		}
		var filtSexe = this.state.filtSexe
		if (filtSexe === 'Tous') {
			filtSexe ='ALLSEXES';
		}

		Axios.get('/api/players' + 
			'/filtPlayers/' + filtPlayers + 
			'/filtRatingTypeId/' + this.state.filtRatingTypeId + 
			'/filtRating/' + filtRating + 
			'/filtSexe/' + filtSexe + 
			'/start/' + pager.startIndex + 
			'/end/' + (pager.endIndex + 1) + 
			'/sortFieldIdx/' + sortParams.sortFieldIdx + 
			'/sortOrder/' + sortParams.sortOrder)
			.then(function(response) {

				var playersData = response.data;
				// console.log('playersData');
				// console.log(playersData);

				// Init this array
				var showRatingsPlayerIdx = new Array(pager.pageSize).fill(false);

				// build data
				_this.buildPlayersTableWithRatings(playersData, showRatingsPlayerIdx, pager, sortParams);
		});	
	}

	buildPlayersTableWithRatings(playersData, showRatingsPlayerIdx, pager, sortParams) {

		// unspecified parameters -> take state
		pager = (pager === undefined) ? this.state.pager : pager;
		sortParams = (sortParams === undefined) ? this.state.sortParams : sortParams;

		var _this = this;
		var tableRows = [];

		playersData.forEach(function (pdata, pdataIdx) {

			var rowPlayerData = {};
			rowPlayerData.dataType = 'player';
			rowPlayerData.dataIdx = pdataIdx;
			rowPlayerData.data = pdata;
			tableRows.push(rowPlayerData);

			if (showRatingsPlayerIdx[pdataIdx]) {

				pdata.ratings.forEach(function (rating, ratingIdx, ratings) {

					var rowRatingData = {};

					var ratingTempStr = '';
					if (rating.ratingTemp) {
						ratingTempStr = '(TEMP)';
					}

					rowRatingData.dataType = 'ratings';
					rowRatingData.dataIdx = ratingIdx;
					rowRatingData.data = {
						date: moment(rating.date).utc().format("YYYY-MM-DD"),
						value: rating.ratingValue,
						temp: ratingTempStr,
						ratingType: rating.ratingTypeId,
						ratingTypeName: rating.ratingTypeName
					};

					tableRows.push(rowRatingData);
				});
			}
		});

		_this.setState({
			playersData: playersData,
			showRatingsPlayerIdx: showRatingsPlayerIdx,
			tableRows: tableRows,
			pager: pager,
			sortParams: sortParams,
			loading: false,
		});
	}

	render() {
		// console.log('Players: render');
		//console.log(this.state);
		//console.log(this.props)
		//console.log('profile: ' + this.state.profile.name + '(' + this.state.profile.user_id + ')');
		//console.log('globalAccessLevel: ' + this.state.adminAccess.globalAccessLevel);
		//console.log('isAdmin: ' + this.state.isAdmin.toString());
		// console.log(this.state.showRatingsPlayerIdx);
		
		var _this = this;
    var pager = this.state.pager;

    var tableWidth = 'col-md-8';
    if (this.state.isAdmin) {
    	tableWidth = 'col-md-11';
    }

		return (
			<div className="animated fadeIn">
        <div className="row">
        <div className="col-md-12 col-xs-12">
          <h4>Joueurs</h4>
          <p>LA PUISSANCE DES STATS</p>
        </div>
        </div>
        <hr/>

        <div className="row">
        <div className="col-md-10 col-xs-12">
        	<p>
        		Joueurs avec des statistiques dans Statelo sous différents systèmes de cotation.<br/>
        		Choisir un système de cotation pour classer et filtrer les joueurs selon une cote en particulier.<br/>
        		Cliquer sur le nom d'un joueur pour voir son historique de cotation.
        	</p>
					<hr/>
				</div>
				</div>

				<div className="row">
				<div className="col-md-10">

					<div className="row">
					<div className="col-md-12">
						<span className="font-weight-bold">FILTRES</span><br/>
					</div>
					</div>
	  
					<div className="row">
					<div className="col-md-6">
						<span>Joueur</span>
	        	<input className="form-control form-control-sm input-sm" type="text" id="filtPlayers" 
	          	value={this.state.filtPlayers} onChange={this.handleFiltPlayersChange}></input>
					</div>
					</div>

					<div className="row">
					<div className="col-md-6">
						<span>Système de cotation</span>
			  		<select className="form-control form-control-sm input-sm" type="text" id="filtRatingTypeId" 
			  			value={this.state.filtRatingTypeId} onChange={this.handleSelectRatingType}>
			  				<option value="0">Tous les systèmes de cotation</option>
			  				{this.state.ratingTypes.map(this.optRatingTypes)}
						</select>
					</div>

					{(this.state.filtRatingTypeId !== '0') ?
						<div className="col-md-6">
							<span>{this.state.filtRatingType.name}</span>
				  		<select className="form-control form-control-sm input-sm" type="text" id="filtRating" 
				  			value={this.state.filtRating} onChange={this.handleFiltRatingChange}>

								<option value='Toutes les cotes' key={'opt.rtv.0'}> Toutes les cotes </option>
								{this.state.filtRatingType.values.map(this.optRatingTypeValues)}
							</select>
						</div>
					: null}
					</div>

					<div className="row">
					<div className="col-md-4">
						<span className="small"> Sexe </span> <br/>
	 		  		<select className="form-control form-control-sm input-sm" type="text" id="filtSexe" 
			  			value={this.state.filtSexe} onChange={this.handleFiltSexeChange}>
							<option value='ALLSEXES' key='optsexe.0'> Tous </option>
							<option value='M' key='optsexe.1'> Masculin </option>
							<option value='F' key='optsexe.2'> Féminin </option>
						</select>
					</div>
					</div>

					<div className="row">
					<div className="col-md-4">
						<button type="button" className="btn btn-primary btn-sm btn-margin-topbottom-10 btn-player-width" 
							onClick={this.initFilters}> Réinitialiser les filtres </button>
					</div>
					</div>

					{(this.state.isAdmin) ?
						<div className="row">
						<div className="col-md-8">
							<button type="button" className="btn btn-primary btn-sm btn-margin-right-20 btn-player-width" 
								onClick={this.handleAddEditPlayerClick.bind(this, {_id: '0'})}> Ajouter un joueur </button>
						</div>
						</div>
						: null}

					<br/>
				</div>
				</div>

				<div className="row">
				<div className={tableWidth + " col-xs-12"}>
					{this.displayModule(pager)}
					{this.displayPagination(pager)}
				</div>
				</div>

				<div className="row">
				<div className="col-md-8">
					<i>{pager.totalItems} résultat{(pager.totalItems>1)?'s ':' '} 
					dans {pager.totalPages} page{(pager.totalPages>1)?'s':''}</i>
				</div>
				</div>

    		{(this.state.isAdmin) ?
					<div className="row">
					<div className="col-xl-3 col-md-4 col-sm-6 col-9">
			  		<select className="form-control form-control-sm input-sm" name="pagesize" id="pagesize" 
			  			value={this.state.pagesize} onChange={this.handlePageSizeChange}>
							<option value={20} key={'ot1'}> 20 éléments par page </option>
							<option value={100} key={'ot2'}> 100 éléments par page</option>
							<option value={500} key={'ot3'}> 500 éléments par page</option>
						</select>
					</div>
					</div>
				: null }

				<br/><br/><br/>
      </div>
		);
	}

	handlePageSizeChange(e) {
		var pager = this.state.pager;
		pager.pageSize = parseInt(e.target.value);
		this.setPage(1, pager, this.state.sortParams);
	}

	optRatingTypes(rt, rtIdx, ratingTypes) {
		return (
			<option value={rt._id} key={'opt.rt.' + rtIdx}> {rt.name} </option>
		)
	}

	optRatingTypeValues(rtv, rtvIdx, ratingTypeValues) {
		return (
			<option value={rtv} key={'opt.rtv.' + rtvIdx}> {rtv} </option>
		)		
	}

	displayModule(pager) {
		if (this.state.loading) {
			return (this.displaySpinner());
		} else {
			return (this.displayData(pager));
		}
	}

	displayData(pager) {
		var sortClass = this.state.sortParams.sortClass;

		// Header for data column
		var dataHeaderText = this.state.filtRatingType.name;
		if (dataHeaderText === '') {
			dataHeaderText = 'Système de cotation';
		}

		return (
			<div>
			<div className="table-responsive">
			<table className="table table-hover table-sm">
			<thead>
	      {(this.state.isAdmin) ? 
				<tr>
		      <th colSpan="2"> </th>
		      <th colSpan="99"> ADMINISTRATON</th>
				</tr> : null}
				<tr>
					<th id='hdr.0' className={"statelo-sorting " + sortClass[0]} onClick={this.handleSortTable}> Nom de famille	</th>
					<th id='hdr.1' className={"statelo-sorting " + sortClass[1]} onClick={this.handleSortTable}> Prénom	</th>
					<th id='hdr.2' className={"statelo-sorting " + sortClass[2]} onClick={this.handleSortTable}> Info	</th>
					<th id='hdr.3' className={"statelo-sorting " + sortClass[3]} onClick={this.handleSortTable}> Sexe	</th>
					<th id='hdr.4' className={"statelo-sorting " + sortClass[4]} onClick={this.handleSortTable}> {dataHeaderText}	</th>
					{(this.state.isAdmin) ? <th id='hdr.5' className={"statelo-sorting " + sortClass[5]} onClick={this.handleSortTable}> Ville </th>  : null}
					{(this.state.isAdmin) ? <th id='hdr.6' className={"statelo-sorting " + sortClass[6]} onClick={this.handleSortTable}> Téléphone </th>  : null}
					{(this.state.isAdmin) ? <th id='hdr.7' className={"statelo-sorting " + sortClass[7]} onClick={this.handleSortTable}> Courriel </th>  : null}
					{/*(this.state.isAdmin) ? <th id='hdr.8' className={"statelo-sorting " + sortClass[8]} onClick={this.handleSortTable}> Last Game Date </th>  : null*/}
		      {(this.state.isAdmin) ? <th id='hdr.8'> Sexe </th> : null}
		      {(this.state.isAdmin) ? <th id='hdr.9'> </th> : null}
				</tr>
			</thead>

			{this.displayTable()}
			</table>

			</div>
			</div>
		);
	}

	displayTable() {
		if (this.state.tableRows.length === 0) {
			return (
				<tbody>
					<tr><td colSpan="99">Aucun joueur</td></tr>
				</tbody>
			)
		} else {
			return (
				<tbody>
					{this.state.tableRows.map(this.createTableRow)}
				</tbody>
			)
		}
	}

	displayPagination(pager) {
		return (
      <ul className="pagination">
        <li className={pager.currentPage === 1 ? 'disabled' : ''}>
          <a onClick={() => this.setPage(1)}>{"<<"}</a>
        </li>
        <li className={pager.currentPage === 1 ? 'disabled' : ''}>
          <a onClick={() => this.setPage(pager.currentPage - 1)}>{"<"}</a>
        </li>
        {pager.pages.map((page, index) =>
  	      <li key={index} className={pager.currentPage === page ? 'active' : ''}>
	          <a onClick={() => this.setPage(page)}>{page}</a>
    	    </li>
        )}
        <li className={pager.currentPage === pager.totalPages ? 'disabled' : ''}>
          <a onClick={() => this.setPage(pager.currentPage + 1)}>{">"}</a>
        </li>
        <li className={pager.currentPage === pager.totalPages ? 'disabled' : ''}>
          <a onClick={() => this.setPage(pager.totalPages)}>{">>"}</a>
        </li>
      </ul>
		);
	}

  createTableRow(row, rowIdx, rows) {
   	// player data or ratings data ?
  	if (row.dataType === 'player') {
  		return (this.createPlayerDataRow(row.data, row.dataIdx))
  	} else {
  		return (this.createPlayerRatingRow(row.data, row.dataIdx, rowIdx))
  	}
	}

  createPlayerDataRow(player, playerIdx) {

  	// add debug column data
  	// console.log(player.lastRatings)
  	var lastQvneaRatingGameDate = "inconnue";
  	player.lastRatings.forEach((pr, prIdx) => {
  		if (pr.ratingTypeId.toString() === "5ece80d5693120e862625805") {
  			if (pr.lastGameDate === "no game played") {
  				lastQvneaRatingGameDate = "aucune partie";
  			} else if (pr.lastGameDate !== "unknown") {
  				lastQvneaRatingGameDate = moment(pr.lastGameDate).utc().format("YYYY-MM-DD");
  			}
  		}
  	});

		var isMasterAdmin = (this.state.adminAccess.globalAccessLevel === ADMIN_LVL_MASTER);
		// console.log(this.state.adminAccess.globalAccessLevel)

		var playerSpecial = "";
		if(player.special !== "") {
			playerSpecial = " (" + player.special + ")";
		}
  	var playerName = player.lastname + ', ' + player.firstname;
		playerName += playerSpecial;

		// ******************************
		// display ratingTypes if no one selected
		// display last rating if ratingType is selected
		var dataColumnValue = '';

		// no ratingType selected
		if (this.state.filtRatingTypeId === '0') {
			if (player.lastRatings.length !== 0) {
				player.ratingTypeNames = player.ratingTypeNames.sort((a, b) => (a.localeCompare(b)));
				dataColumnValue = player.ratingTypeNames.join(', ');
			} else {
				dataColumnValue = '(aucun)'
			}

		// ratingType selected, display latest rating (already sorted by date in api)
		} else {
			var playerLastRatingsFiltered = player.lastRatings.filter((plr) => 
				(plr.ratingTypeId.toString() === this.state.filtRatingTypeId.toString()));
			if (playerLastRatingsFiltered.length !== 0) {
				dataColumnValue = playerLastRatingsFiltered[0].ratingValue;
				if (playerLastRatingsFiltered[0].ratingTemp) {
					dataColumnValue += " (TEMP)"
				}
			}
		}

		var sexeBtnText = "set M";
		if (player.sexe === "M") {
			sexeBtnText = "set F";
		}

    return (
      <tr key={'player.' + playerIdx} className="stateloListItemPointer">

        <td onClick={this.handlePlayerClick.bind(this, playerIdx, player)}>
        	<span id={'tdpname' + playerIdx}> {player.lastname} </span>
        </td>
        <td onClick={this.handlePlayerClick.bind(this, playerIdx, player)}>
        	<span> {player.firstname} </span>
        </td>
        <td onClick={this.handlePlayerClick.bind(this, playerIdx, player)}>
        	<span> {playerSpecial} </span>
        </td>


      	<td onClick={this.handlePlayerClick.bind(this, playerIdx, player)}>
      		{player.sexe}
      	</td>

        {isMasterAdmin ?
				  <Tooltip placement="right" 
				  	target={'tdpname' + playerIdx} toggle={() => {this.toggleTooltip(playerIdx)}}
				  	isOpen={this.state.tooltipOpen[playerIdx]} autohide={false}>
				    <strong>Info supplémentaires (master admin)</strong> <br/>
				    Player Id: {player._id} <br/>
				    Date d'inscription: {moment(player.inscriptionDate).format('YYYY-MM-DD')}
				  </Tooltip>
				: null}

        <td onClick={this.handlePlayerClick.bind(this, playerIdx, player)}>
        	{dataColumnValue}
        </td>
        
        {(this.state.isAdmin) ? 
        	<td onClick={this.handlePlayerClick.bind(this, playerIdx, player)}>
        		{player.city}
        	</td>
        	: null }

        {(this.state.isAdmin) ?
     			<td onClick={this.handlePlayerClick.bind(this, playerIdx, player)}>
    				{player.tel1} <br/>	{player.tel2}
    			</td>
        	: null }

        {(this.state.isAdmin) ?
     			<td onClick={this.handlePlayerClick.bind(this, playerIdx, player)}>
    				{player.email}
    			</td>
        	: null }
{/*
        {(this.state.isAdmin) ?
     			<td onClick={this.handlePlayerClick.bind(this, playerIdx, player)}>
    				{lastQvneaRatingGameDate}
    			</td>
        	: null }
*/}
        {(this.state.isAdmin) ? 
        	<td> 
        		<input name={'togglePlayerSex.' + playerIdx} type="button" 
        			onClick={this.handleTogglePlayerSexClick.bind(this, player)} value={sexeBtnText} />
        	</td>	: null}

        {(this.state.isAdmin) ? 
        	<td> <input name={'edit.' + playerIdx} type="button" 
        	onClick={this.handleAddEditPlayerClick.bind(this, player)} value="Éditer"/> </td>	: null}

      </tr>
    );
  }

  dispPlayerTel(playerIdx, player) {
  	return (
     	<td onClick={this.handlePlayerClick.bind(this, playerIdx, player)}>
    		{player.tel1} <br/>	{player.tel2}
    	</td>
  	)
 	}

  createPlayerRatingRow(rating, ratingIdx, rowIdx) {
    return (
      <tr key={'rating.' + ratingIdx + '.' + rowIdx} id={'tr.' + ratingIdx} className='rating' >
        <td colSpan="99" className="rating-firstcol">{rating.date}&nbsp;&nbsp;&nbsp;&nbsp;
        	{rating.ratingTypeName}&nbsp;&nbsp;&nbsp;&nbsp;{rating.value} {rating.temp} </td>
      </tr>
    );
  }

	handlePlayerClick(playerIdx, player) {
		var showRatingsPlayerIdx = this.state.showRatingsPlayerIdx;
		if (showRatingsPlayerIdx[playerIdx] === true) {
			showRatingsPlayerIdx = new Array(this.state.pager.pageSize).fill(false);
		} else {
			showRatingsPlayerIdx = new Array(this.state.pager.pageSize).fill(false);
			showRatingsPlayerIdx[playerIdx] = true
		}

		this.setState({
			showRatingsPlayerIdx: showRatingsPlayerIdx
		});

		this.buildPlayersTableWithRatings(this.state.playersData, showRatingsPlayerIdx);
	}

	handleAddEditPlayerClick(player) {
		const path = '/players/' + player._id;
		this.props.history.push(path);
	}

	handleTogglePlayerSexClick(player) {
		var _this = this;
		Axios.post('/api/players/togglePlayerSex', {
			playerId: player._id
		}).then(function(response) {

			var tableRows = _this.state.tableRows;
			tableRows.map(tr => {
				if (tr.data._id.toString() === player._id.toString()) {
					if (tr.data.sexe === "M") {
						tr.data.sexe = "F";
					} else {
						tr.data.sexe = "M";
					}
				}
			});
			_this.setState({ tableRows: tableRows	});
		});
	}

	handleFiltPlayersChange(e) {
		// Find page number and set it
    this.setState({
    	filtPlayers: e.target.value
    });
    this.initiatePagerSizeWithData(e.target.value, this.state.filtRatingTypeId, this.state.filtRating, this.state.filtSexe, false);
	}

	handleSelectRatingType(e) {
		var filtRatingType = {name: ''};
		var filtRatingTypeId = e.target.value;
		var ratingTypes = this.state.ratingTypes;

		ratingTypes.forEach(function (rt, rtidx) {
			if (rt._id.toString() === filtRatingTypeId.toString()) {
				filtRatingType = rt;
			}
		});
		
    this.setState({
    	filtRatingTypeId: filtRatingTypeId,
    	filtRatingType: filtRatingType,
    	loading: true
    });
    this.initiatePagerSizeWithData(this.state.filtPlayers, e.target.value, this.state.filtRating, this.state.filtSexe, true);
	}

	handleFiltRatingChange(e) {
    this.setState({
    	filtRating: e.target.value
    });
    this.initiatePagerSizeWithData(this.state.filtPlayers, this.state.filtRatingTypeId, e.target.value, this.state.filtSexe, false);
	}

	handleFiltSexeChange(e) {
    this.setState({
    	filtSexe: e.target.value
    });
    this.initiatePagerSizeWithData(this.state.filtPlayers, this.state.filtRatingTypeId, this.state.filtRating, e.target.value, false);
	}

	initFilters() {
		var filtPlayers = '';
		var filtRatingTypeId = '0';
		var filtRating = 'Toutes les cotes';
		var filtSexe = "Tous";

    this.setState({
    	filtPlayers: filtPlayers,
    	filtRatingTypeId: filtRatingTypeId,
    	filtRating: filtRating,
    	filtSexe: filtSexe,
    	loading: true
    });

    this.initiatePagerSizeWithData(filtPlayers, filtRatingTypeId, filtRating, filtSexe, true);
	}

	/* https://stackoverflow.com/questions/29810914/react-js-onclick-cant-pass-value-to-method */ 
	handleSortTable(e) {
		var colIdx = parseInt(e.target.id.split(".")[1], 10);
		var sortOrder = this.state.sortParams.sortOrder;
		var sortFieldIdx = this.state.sortParams.sortFieldIdx;

		// Toggle sort order
		if (sortFieldIdx === colIdx) {
			if (sortOrder === 'desc') {
				sortOrder = 'asc';
			} else {
				sortOrder = 'desc';
			}
		} else {
			sortOrder = 'asc';
		}

		var sortClass = [];
		for(var i = 0; i < (TABLE_NBCOL - 1); i++) {
			sortClass[i] = '';
		}
		sortClass[colIdx] = "statelo-sorting_" + sortOrder;

		var sortParams = {
			sortFieldIdx: colIdx,
			sortOrder: sortOrder,
			sortClass: sortClass
		};

		this.setPage(1, this.state.pager, sortParams);
	}

	getAdminRightsInfo(callback) {
		var adminAccess = this.state.adminAccess;
		adminAccess.adminValidatedAccessLevel = 99;		// not used here

		if (this.state.isAuthenticated) {
			Users.getAccessLevel(this.state.profile, function(globalAccessLevel) {
				adminAccess.globalAccessLevel = globalAccessLevel;
				callback(adminAccess);
			});

		} else {
			adminAccess.globalAccessLevel = 99;
			callback(adminAccess);
		}
	}

	displaySpinner() {
		return (
  		<div className="sk-three-bounce">
    		<div className="sk-child sk-bounce1"></div>
    		<div className="sk-child sk-bounce2"></div>
    		<div className="sk-child sk-bounce3"></div>
  		</div>
  	);
	}

}

export default Players;
